module.exports = __webpack_public_path__ + "img/admin.3cc68067.svg";